export const UserRoles = {
  ADMIN: 'admin',
  BACKOFFICE: 'backoffice',
  FRONTOFFICE: 'frontoffice',
}

export function getAllUserRoles() {
  return Object.values(UserRoles)
}
